import './style.css';
import ReactDOM from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import Experience from './Experience.jsx';
import { KeyboardControls } from '@react-three/drei';

const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
  <KeyboardControls map={[{ name: 'boost', keys: ['Space'] }]}>
    <Canvas
      shadows
      camera={{
        fov: 45,
        near: 0.1,
        far: 400,
      }}
    >
      <Experience />
    </Canvas>
  </KeyboardControls>
);
